import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg48VideoChat = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey800,
      fillRule: "evenodd",
      d: "M44 0a4 4 0 0 1 4 4v40a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zM28.567 13H12.433a2.933 2.933 0 0 0-2.928 2.761l-.005.172v16.134a2.933 2.933 0 0 0 2.761 2.928l.172.005h16.134a2.933 2.933 0 0 0 2.928-2.761l.005-.172V15.933A2.933 2.933 0 0 0 28.567 13m9.529 3.693-.145.035-3 .858a2 2 0 0 0-1.444 1.757l-.007.166v8.982a2 2 0 0 0 1.293 1.871l.158.052 3 .858a2 2 0 0 0 2.544-1.774l.005-.15V18.652a2 2 0 0 0-2.404-1.958m-23.206.55c.62-.823 1.836-.891 2.58-.147l1.297 1.297c.679.678.69 1.765.028 2.427-.56.56-.55 1.477.023 2.05l2.445 2.444c.572.572 1.49.583 2.05.023.661-.662 1.748-.65 2.426.028l1.298 1.297c.743.744.674 1.96-.149 2.58l-.011.007c-1.946 1.369-4.627 1.112-6.346-.607l-5.04-5.04c-1.72-1.72-1.976-4.4-.608-6.347Z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg48VideoChat$1 = Svg48VideoChat;

export { Svg48VideoChat$1 as default };
